import apiV2 from "api-v2";

import type {
	ApproveRevisionRequestPayload,
	DeclineRevisionRequestPayload,
	EvaluationRevisionRequest,
	EvaluationRevisionUpload,
	UploadRevisionPayload,
} from "../types/revision-review.type";

interface ApiResponse<T> {
	data: T;
	message?: string;
	status: boolean;
}

export const getRevisionRequests = async (
	rfxId: number,
	evaluationId: number
): Promise<EvaluationRevisionRequest[]> => {
	const response = await apiV2.get<ApiResponse<EvaluationRevisionRequest[]>>(
		`rfx/${rfxId}/evaluation/${evaluationId}/revision-requests`
	);
	return response.data?.status ? response.data.data : [];
};

export const getRevisionUploads = async (
	rfxId: number,
	evaluationId: number
): Promise<EvaluationRevisionUpload[]> => {
	const response = await apiV2.get<ApiResponse<EvaluationRevisionUpload[]>>(
		`rfx/${rfxId}/evaluation/${evaluationId}/revisions`
	);
	return response.data?.status ? response.data.data : [];
};

export const uploadRevision = async (
	rfxId: number,
	evaluationId: number,
	payload: UploadRevisionPayload
): Promise<EvaluationRevisionUpload | null> => {
	const formData = new FormData();
	formData.append("rfx_invite_id", String(payload.rfx_invite_id));
	formData.append("revision_type", payload.revision_type);
	if (payload.comment !== undefined && payload.comment !== null) {
		formData.append("comment", payload.comment);
	}
	payload.files.forEach((file) => {
		formData.append("files[]", file);
	});

	const response = await apiV2.post<ApiResponse<EvaluationRevisionUpload>>(
		`rfx/${rfxId}/evaluation/${evaluationId}/revision`,
		formData,
		{
			headers: { "Content-Type": "multipart/form-data" },
		}
	);
	return response.data?.status ? response.data.data : null;
};

export const approveRevisionRequest = async (
	rfxInviteId: number,
	revisionRequestId: number,
	payload: ApproveRevisionRequestPayload
): Promise<EvaluationRevisionRequest | null> => {
	const response = await apiV2.patch<ApiResponse<EvaluationRevisionRequest>>(
		`rfx-invite/${rfxInviteId}/revision-requests/${revisionRequestId}/approve`,
		payload
	);
	return response.data?.status ? response.data.data : null;
};

export const declineRevisionRequest = async (
	rfxInviteId: number,
	revisionRequestId: number,
	payload: DeclineRevisionRequestPayload
): Promise<EvaluationRevisionRequest | null> => {
	const response = await apiV2.patch<ApiResponse<EvaluationRevisionRequest>>(
		`rfx-invite/${rfxInviteId}/revision-requests/${revisionRequestId}/decline`,
		payload
	);
	return response.data?.status ? response.data.data : null;
};
